import script from "./ServicosSecao.vue?vue&type=script&setup=true&lang=js"
export * from "./ServicosSecao.vue?vue&type=script&setup=true&lang=js"

import "./ServicosSecao.vue?vue&type=style&index=0&id=3908d08d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3908d08d"]])

export default __exports__